import React, { FC } from 'react'

import { GenericFeedbackPage } from 'components/generic-feedback-page/components/GenericFeedbackPage'
import { Loader } from 'components'

import { useUnknownErrorPageContextAware } from '../hooks'

const UnknownErrorPageContextAware: FC = () => {
  const { isLoading, content, button } = useUnknownErrorPageContextAware()

  if (isLoading) return <Loader />

  return (
    <GenericFeedbackPage
      icon={content.icon}
      iconColor="var(--error500)"
      title={content.title}
      details={content.details}
      confirmButton={button}
    />
  )
}

export { UnknownErrorPageContextAware }
